import {BaseModel} from "../baseModel";
import {IsEnum, IsNotEmpty, IsOptional, ValidateNested} from "class-validator";
import {Gender} from "../../enums/gender.enum";
import {User} from "../user/user.model";
import moment from "moment";
import {UserSetting} from "../userSetting/userSetting.model";
import {UserCategoryResult} from "../userResults/UserCategoryResult.model";
import {PersonaTheme} from "../../enums/personaTheme.enum";
import {SignInType} from "../../enums/signInType.enum";
import {IsBeforeDate} from "../../validators/isBeforeDate.validator";

class UserProfile extends BaseModel {

    @ValidateNested()
    user?: User;

    userName: string;

    displayName: string;

    @IsBeforeDate(moment().subtract(13, 'years').toDate(), {message: "You must be over 13 years to make an account"})
    @IsNotEmpty({message: "Please enter your date of birth"})
    dateOfBirth: Date;

    @IsNotEmpty({message: "Select an option"})
    gender: Gender;

    @IsOptional()
    @IsNotEmpty()
    customUrlPathName?: string;

    @IsNotEmpty({message: "Select an option"})
    @IsEnum(PersonaTheme)
    theme: PersonaTheme;

    signInType?: SignInType;

    userSettings: UserSetting[];

    @ValidateNested()
    userCategoryResults: UserCategoryResult[];
}

export {UserProfile}